import { ConnectVehicle } from '../models'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useEffect, useState } from 'react'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { fetchConnectVehicles } from '../api/vehicles.api'
import { isEqual } from 'lodash'

interface UseConnectVehicles {
  vehicles: ConnectVehicle[]
  loading: boolean
  error?: Error | AuthFetchError
  hasError: boolean
}

/**
 * Hook for handling vehicles fetching after the user previously authorized via the manufacturer login
 */
const useConnectVehicles = (installationId?: string, vendorAccountId?: string): UseConnectVehicles => {
  const [connectVehicles, setConnectVehicles] = useState<ConnectVehicle[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | AuthFetchError | undefined>(undefined)
  const [hasError, setHasError] = useState(false)
  const authFetch = useAuthFetchWithResponse()

  useEffect(() => {
    const getConnectVehicles = async (vendorAccountId: string): Promise<void> => {
      setLoading(true)
      setHasError(false)
      setError(undefined)
      if (!installationId) return
      const { error, hasErrors, value } = await fetchConnectVehicles(installationId, vendorAccountId, authFetch)
      setHasError(hasErrors)
      if (error) setError(error)
      if (!isEqual(value, connectVehicles)) setConnectVehicles(value ?? [])
      setLoading(false)
    }

    if (vendorAccountId && installationId) getConnectVehicles(vendorAccountId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorAccountId, installationId])

  return { vehicles: connectVehicles, loading, error, hasError }
}

export default useConnectVehicles
